import React from 'react';
import { cn } from '@/utils/cn';
import Icon from '../Icon';
import Text from '../Text';

function ErrorMessage({
  textPrimary = '',
  textSecondary = '',
  className,
  type = 'otpError',
}) {
  const renderErrorMessage = () => {
    if (type === 'otpError') {
      return (
        <div className={cn('flex flex-row gap-[2px]', className)}>
          <div className="mr-0 mt-2">
            <Icon type="wrong-otp" className=" size-[20px] " />
          </div>

          <Text
            type="paragraph"
            className="text-12 lg:text-14 text-center font-medium tracking-[0.24px] lg:tracking-[0.28px] leading-4 lg:leading-5 font-encode-sans !text-infrared-burn ml-0 "
          >
            {textPrimary}
          </Text>
        </div>
      );
    }
    if (type === 'textOnly') {
      return (
        <Text
          type="paragraph"
          className="!text-12 text-left pl-16 w-full !text-infrared-burn mt-4"
        >
          {textPrimary}
        </Text>
      );
    }
    return (
      <div className={cn('flex flex-col gap-[2px] items-center', className)}>
        <div className="flex flex-row gap-[2px] items-center">
          <Icon type="wrong-otp" />
          <Text
            type="paragraph"
            className="!text-12 text-center !text-infrared-burn"
          >
            {textPrimary}
          </Text>
        </div>
        <Text
          type="paragraph"
          className="!text-12 text-center !text-infrared-burn"
        >
          {textSecondary}
        </Text>
      </div>
    );
  };

  return <>{renderErrorMessage()}</>;
}

export default ErrorMessage;
